import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from "@angular/router";
import { InspectionState } from "src/app/inspection/model/inspection-state";
import { InspectionDetailsService } from "src/app/inspection/services/inspection-details.service";
@Injectable({
  providedIn: "root",
})
export class NewInspectionGuard implements CanActivate {
  constructor(
    private inspectionDetailService: InspectionDetailsService,
    private router: Router,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    const inspectionStatus =
      await this.inspectionDetailService.getInspectionStatus(route.params.id);
    if (inspectionStatus == InspectionState.New) {
      return this.router.createUrlTree(["new-inspection", route.params.id]);
    }
    return true;
  }
}
